export const CREATE_EXPENSE_GROUP = 'CREATE_EXPENSE_GROUP';
export const EDIT_EXPENSE_GROUP = 'EDIT_EXPENSE_GROUP';
export const SHOW_EXPENSE_GROUP = 'SHOW_EXPENSE_GROUP';
export const EXPENSE_GROUP_SUCCESS = 'EXPENSE_GROUP_SUCCESS';
export const EXPENSE_GROUP_ERROR = 'EXPENSE_GROUP_ERROR';

